import { render, staticRenderFns } from "./TrademarkPurchase.vue?vue&type=template&id=2d143b4a&scoped=true"
import script from "./TrademarkPurchase.vue?vue&type=script&lang=js"
export * from "./TrademarkPurchase.vue?vue&type=script&lang=js"
import style0 from "./TrademarkPurchase.vue?vue&type=style&index=0&id=2d143b4a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d143b4a",
  null
  
)

export default component.exports